import { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import CarPage from "./pages/CarPage";
import CarSettingsPage from "./pages/CarSettingsPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import ProfilePage from "./pages/ProfilePage";
import RawPage from "./pages/RawPage";
import ReportPage from "./pages/ReportPage";
import SettingsPage from "./pages/SettingsPage";
import SessionManager from "./manager/SessionManager";
import AppContext from "./AppContext";

const App = () => {
  const sessionManager = new SessionManager();

  const [accessToken, setAccessToken] = useState(
    sessionManager.getAccessToken(),
  );
  const [pagePaths, setPagePaths] = useState(sessionManager.getPagePaths());

  const setAccessTokenInSession = (newAccessToken) => {
    setAccessToken(newAccessToken);
    sessionManager.setAccessToken(newAccessToken);
  };

  const setPagePathsInSession = (newPagePaths) => {
    setPagePaths(newPagePaths);
    sessionManager.setPagePaths(newPagePaths);
  };

  if (!accessToken) {
    return (
      <AppContext.Provider
        value={{
          accessToken,
          setAccessToken: setAccessTokenInSession,
          pagePaths,
          setPagePaths: setPagePathsInSession,
        }}
      >
        <LoginPage />
      </AppContext.Provider>
    );
  } else {
    return (
      <AppContext.Provider
        value={{
          accessToken,
          setAccessToken: setAccessTokenInSession,
          pagePaths,
          setPagePaths: setPagePathsInSession,
        }}
      >
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="car" element={<CarPage />} />
              <Route path="car-settings" element={<CarSettingsPage />} />
              <Route path="report" element={<ReportPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="raw" element={<RawPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppContext.Provider>
    );
  }
};

export default App;
